import { HighestCampaignsSection } from './HighestCampaignsSection';
import { PercentageInsightPanel, PercentageInsightPanelProps } from './PercentageInsightPanel';

type ConversionRatePanelProps = Omit<PercentageInsightPanelProps, 'children'> & {
  isLoading?: boolean;
};

export const ConversionRatePanel = ({
  title,
  percentage,
  showSelect,
  isLoading,
  isEmpty,
}: ConversionRatePanelProps) => (
  <PercentageInsightPanel
    title={title}
    percentage={percentage}
    showSelect={showSelect}
    isLoading={isLoading}
    isEmpty={isEmpty}
  >
    {Number.isFinite(percentage) && <HighestCampaignsSection />}
  </PercentageInsightPanel>
);
